import BaseRepository from "./BaseRepository";

export default class RecordRepository extends BaseRepository {

	constructor() {
		super();
    this.getComunication = this.getComunication.bind(this);
    this.getMensuration = this.getMensuration.bind(this);
    this.getManagement = this.getManagement.bind(this);
  }

  async getComunication(token) {
    return await this.get(`/records/comunication?token=${token}`);
  }
  async getMensuration(token) {
    return await this.get(`/records/mensuration?token=${token}`);
  }
  async getManagement(token) {
    return await this.get(`/records/menagement?token=${token}`);
  }
}


// WEBPACK FOOTER //
// src/api/lib/RecordRepository.js